import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/superintendentsAndProjectManagersInCompanyWithEmail`;

export const ROUTE: RouteDefinition = `${baseRoute}/superintendentsAndProjectManagersInCompanyWithEmail`;

export const URL = (): RouteDefinition => `${baseRoute}/superintendentsAndProjectManagersInCompanyWithEmail`;
